// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"95d36eb1","314":"6acdd7a2","422":"55a051f5","869":"c45f7af0","982":"7dd91ccc"}[chunkId] + ".chunk.js";
};